import React, { memo, useMemo } from 'react';
import { LabelType, MyAnalyticsDimensionType } from 'graphql/types';
import { useGetMyAnalyticsData } from 'modules/Insights/Notes/hooks/useGetMyAnalyticsData';
import { transformLabelData } from './utils';
import ProgramComponent from './ProgramComponent';

export const ProgramChart: React.FC = () => {
  const { data, loading = true, isEmpty } = useGetMyAnalyticsData(
    MyAnalyticsDimensionType.MetricsByProgram
  );

  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.myAnalytics?.items, LabelType.Program);
    }
  }, [data?.myAnalytics?.items, isEmpty]);

  return (
    <ProgramComponent data={dataset} loading={loading} isEmpty={isEmpty} />
  );
};
export default memo(ProgramChart);
